/**
 * Mobile-only settings sheet, opened by BuilderIdentityBand's settings
 * toggle. Covers the body from below the app bar + identity band down
 * (`top: 116px` = 56 + 60); both stay visible so the toggle that opened it
 * is still reachable to close it.
 * Spec: assets/handoffs/design_handoff_builder_header, Rules — mobile band
 * / the settings sheet.
 *
 * One back arrow on screen, ever: the band's arrow leaves the page, this
 * sheet only ever closes with the X — never a second chevron.
 *
 * The sheet is given its own history entry by the caller (CalendarPage/
 * AlertPage push a `#settings` hash to open it) so the device back gesture
 * closes the sheet instead of leaving the builder; this component itself is
 * just presentation and re-runs the legacy jQuery/Bootstrap tab bindings
 * on mount since the Setup/Design/Install strip inside `children` is the
 * same `data-toggle="tab"` markup the desktop panel uses.
 *
 * @param {boolean} open
 * @param {function} onClose
 * @param {string} title
 * @param {ReactNode} children - the existing Setup/Design/Install nav + tab-content
 */
import React, { useEffect } from "react";
import Icon from "../../../theme/untitled/icons/Icon";
import { updateJquery } from "../../../tools";
import styles from "./BuilderSettingsSheet.module.scss";

const BuilderSettingsSheet = ({ open, onClose, title, children }) => {
  useEffect(() => {
    if (open) updateJquery();
  }, [open]);

  if (!open) return null;

  return (
    <div className={styles.sheet}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <button
          type="button"
          title="Close settings"
          aria-label="Close settings"
          className={styles.close}
          onClick={onClose}
        >
          <Icon name="XClose" size={20} />
        </button>
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
};

export default BuilderSettingsSheet;
